module.exports = __webpack_public_path__ + "static/img/wechat.359b2ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat.png
// module id = oB+8
// module chunks = 1